export enum TextBoxTypeEnum {
  PrintCode = 'printCode',
  Text = 'text',
  Number = 'number',
  Date = 'date',
  Time = 'time',
  Mobile = 'mobile',
  Color = 'color',
  Password = 'password',
}
